<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 border border-blueGray-200 rounded-lg bg-white"
  >
    <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full max-w-full flex-grow flex-1">
          <h6 class="uppercase text-blueGray-400 mb-1 text-xs">
            Overview
          </h6>
          <h2 class="text-blueGray-700 text-lg">
            <i class="pi pi-server"></i> {{ title }}
          </h2>
        </div>
      </div>
    </div>
    <div class="p-4 flex-auto">
      <div class="relative h-350-px">
        <canvas ref="canvas"></canvas>
      </div>
    </div>
  </div>
</template>
<script>
// A separate component (rather than reusing CardBarChart) mainly because that one
// locates its canvas via a hardcoded `document.getElementById("bar-chart")`, which
// only works while exactly one bar chart exists on the page — using a template ref
// here instead means this can render alongside the existing User Registration chart
// without the two stealing each other's canvas.
import Chart from "chart.js";

export default {
  props: ["data", "title"],
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.init(this.data);
  },
  beforeUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    init(data) {
      this.$nextTick(() => {
        const chartData = data || this.data;

        // Refresh the existing instance's data in place instead of destroying and
        // recreating it — destroy+recreate was still leaving the canvas blank after
        // a data update (e.g. the dashboard's background refresh poll), since tearing
        // down and immediately rebuilding a responsive chart on the same canvas races
        // with the browser re-measuring that canvas. Chart.js already supports
        // pushing new data into a live instance via update(); only build a fresh
        // instance the first time (or if it was destroyed).
        if (this.chart) {
          this.chart.data = chartData;
          this.chart.update();
          return;
        }

        const config = {
          type: "bar",
          data: chartData,
          options: {
            maintainAspectRatio: false,
            responsive: true,
            tooltips: {
              mode: "index",
              intersect: false,
            },
            hover: {
              mode: "nearest",
              intersect: true,
            },
            legend: {
              labels: {
                fontColor: "rgba(0,0,0,.4)",
              },
              align: "end",
              position: "bottom",
            },
            scales: {
              xAxes: [
                {
                  stacked: true,
                  gridLines: { display: false },
                },
              ],
              yAxes: [
                {
                  stacked: true,
                  gridLines: {
                    borderDash: [2],
                    drawBorder: false,
                    color: "rgba(33, 37, 41, 0.2)",
                  },
                },
              ],
            },
          },
        };
        const ctx = this.$refs.canvas.getContext("2d");
        this.chart = new Chart(ctx, config);
      });
    }
  },
  watch: {
    data(newdata) {
      this.init(newdata);
    }
  }
};
</script>
